var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"purchase-method-detail-file-info"},[_c('file-manage',{attrs:{"file-data-ids":_vm.data.overFileIds,"funs":{get: true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }